import { CheckBlock } from './CheckBlock.jsx';
import { DcmaCard } from './DcmaCard.jsx';

function collectCategoryDcma(category, allDcmaPoints) {
  if (!Array.isArray(allDcmaPoints) || allDcmaPoints.length === 0) return [];
  const nums = new Set();
  for (const check of category.checks || []) {
    for (const n of check.dcma_points || []) nums.add(n);
  }
  if (nums.size === 0) return [];
  return allDcmaPoints
    .filter((p) => p && nums.has(p.dcmaNumber))
    .sort((a, b) => a.dcmaNumber - b.dcmaNumber);
}

/**
 * Panel that appears below a CategoryRow when it is open. Renders:
 *   - A "DCMA COMPLIANCE" label + DcmaCards row (when the category's checks
 *     map to DCMA points), matching the reference layout.
 *   - Each check as an independent accordion (siblings stay open when one
 *     is toggled).
 */
export function CategoryExpanded({ category, reportId, dcmaPoints }) {
  // D-DashHiddenChecks (ORACLE2 Step 4.2, amendment v3.20 §1): stage-hidden
  // checks (hidden: true — e.g. #26/#27 on a zero-actuals file, v3.12 V-1)
  // must be ABSENT from the DOM, exactly as the PDF omits them per check
  // (check-block-assembler.js:458). This is the ONE site that constructs the
  // dashboard's per-check list — both consumers (CategoryAccordion on the
  // health tab, DetailedFindings on the findings tab) and the DCMA-card
  // collection below all flow through it, so the filter lives here and only
  // here. Category-level hiding (#31–35 via the hidden Baseline category) is
  // untouched — that filter stays in CategoryAccordion/DetailedFindings.
  const checks = (category.checks || []).filter((c) => !c.hidden);
  const catDcma = collectCategoryDcma({ ...category, checks }, dcmaPoints);
  if (checks.length === 0) {
    return (
      <div id={`cat-panel-${category.id}`} className="cat-expanded empty">
        <p className="table-empty">No checks ran for this category.</p>
      </div>
    );
  }
  return (
    <div id={`cat-panel-${category.id}`} className="cat-expanded" role="region">
      <div className="cat-expanded-inner">
        {catDcma.length > 0 && (
          <>
            <div className="dcma-label">DCMA COMPLIANCE</div>
            <div className="dcma-cards">
              {catDcma.map((p) => (
                <DcmaCard key={p.dcmaNumber} point={p} />
              ))}
            </div>
          </>
        )}
        {checks.map((check) => (
          <CheckBlock
            key={check.check_number}
            check={check}
            reportId={reportId}
          />
        ))}
      </div>
    </div>
  );
}
